import _ from 'lodash';

import PropTypes from 'prop-types';

import RoomTypeCard from './room-type-card.component';

const RoomTypesList = (props) => {
    const { roomTypes, allPortfolios } = props;

    const renderRoomCards = () => {
        if (!roomTypes) {
            return null;
        }
        return _.map(roomTypes, (roomType) => {
            return (
                <div className='main-grid-item main-grid-xl-4 main-grid-lg-4 main-grid-md-4 main-grid-sm-6 main-grid-xs-12' key={roomType.id}>
                    <RoomTypeCard roomType={roomType} allPortfolios={allPortfolios} />
                </div>
            );
        });
    };

    return (
        <>
            <div id="apartment-types-grid" className='main-grid-container main-grid-spacing-xs-4'>
                {renderRoomCards()}
            </div>
        </>
    );
};

export default RoomTypesList;

RoomTypesList.propTypes = {
    roomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    allPortfolios: PropTypes.arrayOf(PropTypes.object),
};

